import styled from 'styled-components'
import { RequestService } from '../../../services/RequestService'
import IntakeSleep from './IntakeSleep'
import { useSnackbar } from '../../../hooks'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 44px;
`

const Sleep = ({
  id,
  sleepTime,
  awakeTime,
  onSleepChange,
  onAwakeChange,
  onPrevious,
  onFinish,
}) => {
  const { errorSnackbar } = useSnackbar()
  const { t } = useTranslation('common')

  const handleFinish = async () => {
    const { status, data } = await RequestService.updateIntake({
      id,
      type: 'sleep',
      sleepTime,
      awakeTime,
    })

    if (status === RequestService.STATUSES.SUCCESS) {
      onFinish()
    } else {
      errorSnackbar({ text: data?.message })
    }
  }

  return (
    <Container>
      <IntakeSleep
        step={t('intake_list.step_one_of_one')}
        onNext={() => handleFinish()}
        onPrevious={onPrevious}
        sleepTime={sleepTime}
        awakeTime={awakeTime}
        onSleepChange={onSleepChange}
        onAwakeChange={onAwakeChange}
      />
    </Container>
  )
}

export default Sleep
